import React, { useRef, useState, useEffect } from "react";
import { KontentRichText, CtaProps } from "../../types";
import CloseButton from "../../components/elements/CloseButton/CloseButton";
import { Cta } from "../../components/elements/Cta/Cta";
import { CustomRichTextElement } from "../../components/elements/CustomRichTextElement/CustomRichTextElement";
import * as styles from "./AlertBanner.module.css";
import Cookies from "js-cookie";

interface Props extends CtaProps {
  style: "green_background" | "white_background";
  publishDate: string;
  unpublishDate: string;
  text: KontentRichText;
  id: string;
}

export const AlertBanner: React.FC<Props> = ({
  text,
  ctaHref,
  ctaLabel,
  ctaTarget,
  ctaAriaLabel,
  id,
  style,
}) => {
  const [visible, setVisible] = useState(false);
  const [bannerElHeight, setBannerElHeight] = useState(200);
  const containerEl = useRef(null);
  const bannerCookieName = `banner${id}`;
  const alertBannerClasses = [styles.alertbanner];
  !visible && alertBannerClasses.push(styles.hidden);
  style === "white_background" &&
    alertBannerClasses.push(styles.whiteBackground);

  const handleCloseButtonClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setVisible(!visible);
    Cookies.set(bannerCookieName, "true");
  };

  useEffect(() => {
    setBannerElHeight(containerEl?.current?.offsetHeight || 200);
  }, [containerEl.current]);

  useEffect(() => {
    const consent = Cookies.get(bannerCookieName);

    if (!consent) {
      setVisible(true);
    }
  }, []);

  return (
    <>
      <div
        data-kontent-component-id={id}
        className={alertBannerClasses.join(" ")}
        ref={containerEl}
      >
        <CustomRichTextElement
          content={text}
          data-kontent-element-codename="text"
        />
        {ctaHref && ctaLabel && (
          <Cta
            href={ctaHref}
            label={ctaLabel}
            target={ctaTarget}
            ariaLabel={ctaAriaLabel}
            data-kontent-element-codename="link_configuration__link"
          />
        )}
        <CloseButton
          onClick={handleCloseButtonClick}
          color={style === "white_background" ? "#205c40" : "#fff"}
        />
      </div>
      {visible && (
        <style
          dangerouslySetInnerHTML={{
            __html: `
        [class^=HomeHero-module--hero] img {
          min-height: calc(100vh + ${bannerElHeight}px);
        }
        [class^=HomeHero-module--overlay] {
          min-height: calc(100vh + ${bannerElHeight}px);
        }
      `,
          }}
        />
      )}
    </>
  );
};
